var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_CONFIRM_MODAL, CLOSE_CONFIRM_MODAL, CONFIRM_MODAL_LOADING_START, CONFIRM_MODAL_LOADING_STOP, } from './actions';
export var initialState = {
    isModalOpened: false,
    modalParams: {
        confirmButtonProps: {
            text: '',
        },
        cancelButtonProps: {
            text: '',
        },
        title: '',
        size: 'm',
        content: null,
    },
    isConfirmModalLoading: false,
};
export var confirmModalModuleReducer = function (state, _a) {
    if (state === void 0) { state = initialState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case SET_CONFIRM_MODAL:
            return __assign(__assign({}, state), { isModalOpened: true, modalParams: payload });
        case CLOSE_CONFIRM_MODAL:
            return __assign(__assign({}, state), { isModalOpened: false });
        case CONFIRM_MODAL_LOADING_START:
            return __assign(__assign({}, state), { isConfirmModalLoading: true });
        case CONFIRM_MODAL_LOADING_STOP:
            return __assign(__assign({}, state), { isConfirmModalLoading: false });
        default:
            return state;
    }
};
